import { IRole, ISector } from "types/PersonalInfo";

import { gaTracking, getCurrentPageLocation, normalizeString } from "../../lib/ga";

/**
 * Tracks scroll depth on pages
 * @param scrollLevel - Percentage of page scrolled (25, 50, 75, or 90)
 * @see /GAExamples/scroll.js
 */
export const layoutScrollTracker = (scrollLevel: 25 | 50 | 75 | 90): void => {
  gaTracking({
    event: "scroll",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      scroll_level: scrollLevel,
    },
  });
};

/**
 * Tracks virtual pageviews with user personalization context
 * @param role - User's employment role
 * @param sector - User's employment industry/sector
 * @param headCategory - Main page category
 * @param subCategory - Page subcategory
 * @param pageReferrer - Referring page URL
 * @param pageTitle - Title of the page
 * @see /GAExamples/virtual_pageview.js
 */
export const virtualPageviewTracker = (
  role: IRole,
  sector: ISector,
  headCategory: string,
  subCategory: string,
  pageReferrer: string,
  pageTitle: string,
  insuranceSelector?: string,
  pagePersonalize?: string,
): void => {
  const eventParameters = {
    page_category: headCategory,
    page_subcategory: subCategory,
    page_referrer: pageReferrer || "",
    page_location: getCurrentPageLocation(),
    page_title: pageTitle,
    insurance_selector: insuranceSelector ?? "",
    page_personalize: pagePersonalize ?? "other",
  };

  gaTracking({
    event: "virtual_pageview",
    user_properties: {
      employment_role: normalizeString(role?.defaultName) ?? "",
      employment_industry: normalizeString(sector?.defaultName) ?? "",
    },
    event_parameters: eventParameters,
  });
};
